/**
 * Geometry of the line view's rail column (Figma `9250:17232`): rails 24 px
 * apart, the first rail's centre 14 px in, 14 px to the column's right edge.
 */
export const RailGeometry = Object.freeze({
  PITCH: 24,
  /** Centre x of `rail` in the column. */
  x: (rail: number): number => 14 + 24 * rail,
  /** Column width for `rails` rails: 28 for one, +24 per extra rail. */
  width: (rails: number): number => 28 + 24 * (rails - 1),
})
